import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AppListComponent } from '../core/list/app-list-component';
import type { HelpItem } from '../../models/api/core/configs/help-item';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { DrawerComponent } from '../core/panels/drawer.component';
import { HelpLinkService } from '../../services/help-link/help-link.service';

@Component({
  selector: 'app-help-side-drawer',
  imports: [
    DrawerComponent,
    AppListComponent,
    ActionRowComponent,
    ButtonComponent,
  ],
  template: `
    <app-drawer
      [(visible)]="visible"
      position="right"
      styleClass="help-side-drawer"
      title="Help"
    >
      <span
        class="tw-mb-2 tw-text-[16px] tw-font-semibold tw-text-[var(--sed-black-80-color)]"
      >
        Video guides
      </span>
      <app-list [items]="videoLinks" />
      <app-action-row class="tw-pt-4">
        <app-button
          left1
          label="Open general help page"
          icon="pi-external-link"
          emphasis="High"
          (click)="onHelpClick()"
        />
      </app-action-row>
    </app-drawer>
  `,
  styles: ``,
})
export class HelpSideDrawerComponent extends BaseComponent implements OnInit {
  private helpLink = inject(HelpLinkService);

  _visible = false;

  videoLinks: HelpItem[] = [];

  @Input()
  get visible(): boolean {
    return this._visible;
  }
  set visible(value: boolean) {
    this._visible = value;
    this.visibleChange.emit(value);
  }

  @Output()
  visibleChange = new EventEmitter<boolean>();

  async ngOnInit(): Promise<void> {
    const config = await this.api.configs.get();
    this.videoLinks = config.header.helpItems.map((item) => ({
      key: item.key,
      icon: 'fa-play fa-light',
      url: item.url,
      label: item.label,
    }));
  }

  async onHelpClick(): Promise<void> {
    const url = await this.helpLink.getHelpUrl();
    if (url) {
      window.open(url, '_blank');
    }
  }
}
